(function(){
  function tidy(el){ if(!el) return; var t = el.textContent; var i = t.indexOf('~'); if(i > 0){ el.textContent = t.slice(0, i).trim(); } }
  function tidyTitles(){
    tidy(document.querySelector('.collection--title'));
    tidy(document.querySelector('.rani-colhero__title'));
    var bc = document.querySelector('.breadcrumbs-container'); if(bc){ var items = bc.querySelectorAll('span, a'); if(items.length){ tidy(items[items.length - 1]); } }
  }
  function ozFromTitle(t){
    var m = t.match(/([\d.]+)\s*(?:ounce|oz)\b/i); if(m) return parseFloat(m[1]);
    m = t.match(/([\d.]+)\s*(?:pound|lb)s?\b/i); if(m) return parseFloat(m[1]) * 16;
    m = t.match(/\(([\d.]+)\s*g\)/i); if(m) return parseFloat(m[1]) / 28.3495;
    m = t.match(/([\d.]+)\s*kg\b/i); if(m) return parseFloat(m[1]) * 35.274;
    return null;
  }
  function perOz(){
    if(!/^\/products\//.test(location.pathname)) return;
    fetch(location.pathname + '.js').then(function(r){ return r.json(); }).then(function(p){
      if(!p || !p.variants || p.variants.length < 2) return;
      var byTitle = {};
      p.variants.forEach(function(v){ var oz = ozFromTitle(v.title); if(oz && oz > 0){ byTitle[v.title.trim()] = (v.price / 100) / oz; } });
      var labels = document.querySelectorAll('.options-selection__option-value-label, .product-form fieldset label');
      labels.forEach(function(l){
        if(l.querySelector('.rani-ppo')) return;
        var key = l.textContent.trim();
        var match = null;
        for(var t in byTitle){ if(t.indexOf(key) === 0 || key.indexOf(t.split(' ~ ')[0].trim()) === 0){ match = byTitle[t]; break; } }
        if(match === null && byTitle[key] !== undefined){ match = byTitle[key]; }
        if(match !== null){ var s = document.createElement('span'); s.className = 'rani-ppo'; s.textContent = '$' + match.toFixed(2) + '/oz'; l.appendChild(s); }
      });
    }).catch(function(){});
  }
  function stickyAtc(){
    if(!/^\/products\//.test(location.pathname)) return;
    if(window.innerWidth > 820) return;
    var form = document.querySelector('.product-form');
    var realBtn = document.querySelector('.product-form button[type="submit"], .product-form--atc-button');
    if(!form || !realBtn || document.querySelector('.rani-sticky-atc')) return;
    var title = (document.querySelector('.product-title') || {}).textContent || '';
    var price = (document.querySelector('.product-pricing .money, .product-pricing .price') || {}).textContent || '';
    var bar = document.createElement('div'); bar.className='rani-sticky-atc';
    bar.innerHTML = '<div class="rani-sticky-atc__info"><div class="rani-sticky-atc__t"></div><div class="rani-sticky-atc__p"></div></div><button type="button" class="rani-sticky-atc__btn">Add to cart</button>';
    bar.querySelector('.rani-sticky-atc__t').textContent = title.trim().slice(0, 60);
    bar.querySelector('.rani-sticky-atc__p').textContent = price.trim().slice(0, 20);
    bar.querySelector('.rani-sticky-atc__btn').addEventListener('click', function(){ realBtn.click(); });
    document.body.appendChild(bar);
    var io = new IntersectionObserver(function(entries){
      bar.classList.toggle('rani-sticky-atc--on', !entries[0].isIntersecting);
    }, {threshold: 0});
    io.observe(form);
  }
  function soldOutLast(){
    if(location.pathname !== '/' && location.pathname !== '') return;
    document.querySelectorAll('.productgrid--items').forEach(function(grid){
      var sold = [];
      grid.querySelectorAll(':scope > *').forEach(function(item){ if(/sold out/i.test(item.textContent)) sold.push(item); });
      sold.forEach(function(item){ grid.appendChild(item); });
    });
  }
  function fmtToggle(){
    if(!/^\/products\//.test(location.pathname)) return;
    if(document.querySelector('.rani-fmt')) return;
    var wraps = Array.prototype.slice.call(document.querySelectorAll('.options-selection__option-value'));
    if(wraps.length < 3) return;
    var getLab = function(w){ return w.querySelector('.options-selection__option-value-label'); };
    var txtNode = function(l){ var best=null; l.childNodes.forEach(function(n){ if(n.nodeType===3 && n.textContent.trim().length > 2){ if(!best || n.textContent.length > best.textContent.length) best=n; } }); return best; };
    var fmtOf = function(w){ var inp=w.querySelector('input'); if(!inp) return null; var t=inp.value||''; var i=t.indexOf('~'); return i>-1 ? t.slice(i+1).trim() : null; };
    var fmts = [];
    wraps.forEach(function(w){ var f=fmtOf(w); if(f && fmts.indexOf(f)<0) fmts.push(f); });
    if(fmts.length < 2) return;
    // strip ' ~ Fmt' from visible labels (keep $/oz span intact)
    wraps.forEach(function(w){ var l=getLab(w); if(!l || l.dataset.raniDone) return; var spans=l.querySelectorAll('span'); for(var i=0;i<spans.length;i++){ var sp=spans[i]; if(/~/.test(sp.textContent) && !sp.classList.contains('rani-ppo')){ sp.textContent = sp.textContent.split('~')[0].trim(); l.dataset.raniDone='1'; break; } } });
    var bar = document.createElement('div'); bar.className='rani-fmt';
    var apply = function(fmt){
      bar.querySelectorAll('.rani-fmt__btn').forEach(function(b){ b.classList.toggle('rani-fmt__btn--on', b.textContent===fmt); });
      var firstVisible=null, selHidden=false;
      wraps.forEach(function(w){ var f=fmtOf(w); var show = (f===fmt || f===null); w.style.display = show ? '' : 'none'; var input=w.querySelector('input');
        if(show && !firstVisible) firstVisible=w;
        if(!show && input && input.checked) selHidden=true; });
      if(selHidden && firstVisible){ var inp=firstVisible.querySelector('input'); if(inp){ inp.click(); } }
    };
    fmts.forEach(function(f){ var b=document.createElement('button'); b.type='button'; b.className='rani-fmt__btn'; b.textContent=f; b.addEventListener('click', function(){ apply(f); }); bar.appendChild(b); });
    var host = wraps[0].closest('fieldset') || wraps[0].parentElement;
    host.parentElement.insertBefore(bar, host);
    // default to the currently selected option's format
    var cur = null; wraps.forEach(function(w){ var i=w.querySelector('input'); if(i && i.checked) cur = fmtOf(w); });
    apply(cur || fmts[0]);
  }
  function run(){ tidyTitles(); perOz(); setTimeout(perOz, 1800); setTimeout(perOz, 4000); stickyAtc(); setTimeout(stickyAtc, 2500); soldOutLast(); setTimeout(soldOutLast, 2500); setTimeout(fmtToggle, 1200); setTimeout(fmtToggle, 3500); }
  if(document.readyState === 'loading'){ document.addEventListener('DOMContentLoaded', run); } else { run(); }
})();

/* Top-nav: parent items with dropdowns are not links (Suneel 9/4) — delegated, covers sticky-header nav clones */
(function raniNavParents(){
  document.addEventListener('click', function(e){
    var a = e.target && e.target.closest ? e.target.closest('.site-navigation a') : null;
    if(!a) return;
    var li = a.closest('li');
    if(!li || li.parentElement.closest('li')) return; // top level only
    var sub = li.querySelector('ul, [class*="submenu"], [class*="meganav"]');
    if(sub){ e.preventDefault(); }
  }, true);
})();

/* Free-shipping progress bar (9/6) */
(function(){
  var T = 2500;
  function fmt(c){ return '$' + (c/100).toFixed(2); }
  function ensure(){
    if (!document.body.classList.contains('template-cart')) return null;
    var host = document.querySelector('header.cart-title');
    if (!host) return null;
    var el = document.querySelector('.rani-freeship');
    if (!el) {
      el = document.createElement('div');
      el.className = 'rani-freeship';
      el.innerHTML = '<div class="rani-freeship__msg"></div><div class="rani-freeship__bar"><span></span></div>';
      host.parentNode.insertBefore(el, host.nextSibling);
    }
    return el;
  }
  function update(){
    var el = ensure(); if (!el) return;
    fetch('/cart.js').then(function(r){ return r.json(); }).then(function(c){
      var t = c.total_price;
      var msg = el.querySelector('.rani-freeship__msg');
      var fill = el.querySelector('.rani-freeship__bar span');
      fill.style.width = Math.min(100, Math.round(t / T * 100)) + '%';
      if (t >= T) { el.classList.add('is-free'); msg.textContent = 'Your order qualifies for FREE shipping!'; }
      else { el.classList.remove('is-free'); msg.textContent = "You're " + fmt(T - t) + ' away from FREE shipping'; }
    }).catch(function(){});
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', update); else update();
  document.addEventListener('click', function(e){
    if (e.target.closest && e.target.closest('.cartitems, [data-quantity-button], .quantity')) setTimeout(update, 900);
  });
})();
